var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAddPostil_),expression:"isAddPostil_"}],class:{backColorB: _vm.bCb},attrs:{"id":"postilBox"}},[_c('div',{staticClass:"addBox"},[_c('i',{on:{"click":_vm.addInsert}})])])}
var staticRenderFns = []

export { render, staticRenderFns }